import { Injectable } from '@angular/core';
import {Subject, Observable, BehaviorSubject, forkJoin, of} from 'rxjs';
import { tap, map } from 'rxjs';
import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private newUserLoggedModel = new BehaviorSubject<boolean>(false);
  newUserLoggedModel$ = this.newUserLoggedModel.asObservable();

  // private newUserLoggedModel = new Subject<string>();
  // newUserLoggedModel$ = this.newUserLoggedModel.asObservable();

  private userDetails = new Subject<any> ();
  userDetails$ = this.userDetails.asObservable();

  private newUserModel = new Subject<string>();
  newUserModel$ = this.newUserModel.asObservable();

  private evnSubj = new Subject<any>();
  
  constructor(
    public apiService: ApiService
  ) {}

  setOnUserLogged(logModel: any) {
    this.newUserLoggedModel.next(logModel);
  }

  getOnUserLogged(): boolean | undefined {
    return this.newUserLoggedModel.getValue();
  }

  dispatchEvent(dat: string) {
    this.evnSubj.next({ data: dat });
  }

  changeUserDetails(usrModel: any) {
    this.newUserModel.next(usrModel);
  }

  setUserDetails(userData: any){
    this.userDetails.next(userData)
  }

  public getObjectKeys(obj: Object) {
    const keys = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        keys.push(p);
      }
    }
    return keys;
  }

  public getObjectValues(obj: Object | any) {
    const values = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        values.push(obj[p]);
      }
    }
    return values;
  }

  /**
   * Returns a value from multi dia array if the criteria matches.
   * @param arr Array to be searched
   * @param matchKey Key to be searched
   * @param matchVal Value to be matched
   * @param reqKey Key of the value to be returned
   */
  getValueFromArr(arr: any[], matchKey: any, matchVal: any, reqKey: any) {
    let val: any;
    if (!arr) {
      return val;
    }
    arr.forEach((itm, i) => {
      if (itm[matchKey] === matchVal) {
        val = itm[reqKey];
      }
    });
    return val;
  }

  public getRightsByToken(getRightsParam: any[]): Observable<any> {
    const requests = getRightsParam.map((param) =>
      this.apiService.getService('user/getRightsByToken', param)
    );
    return forkJoin(requests);
  }
}

